import { makeStyles } from '@material-ui/core/styles';

const customAssetRowStyle = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.primary,
        display: 'flex',
        justifyContent: 'space-around'

    },
    innerTabPanel: {
        width: "80%"
    },
    indicator1:
    {
        direction: "ltr",
        right: "0",
        width: "10px"
    },
    verticalTabs:
    {
        marginRight: "20px"
    },
    rightAlign: {
        'text-align': "right",
        "paddingRight": "24px"
    },
    leftAlign: {
        'text-align': "left",
        "paddingLeft": "24px"
    },
    flexTabRow: {
        display: "flex",
        justifyContent: "center"
    },
    flexTabRowInner: {
        display: "flex",
        justifyContent: "center",
        alignSelf: "center",
        whiteSpace: "nowrap"
    },
    customTabWrapper: {
        justifyContent: "flex-start"
    },
    tooltip: {
        textAlign: "left",
        border: "1px solid" + theme.palette.primary.main,
        backgroundColor: "white",
        color: "black",
        fontSize: "1em"
    },
    arrow: {
        fontSize: 16,
        width: 17,
        "&::before": {
            border: "1px solid" + theme.palette.primary.main,
            backgroundColor: "#fff",
            boxSizing: "border-box"
        }
    },
    buttonTooltip: {
        padding: "0 0 0 5px",
        margin: 0
    },
    buttonColor: {
        color: theme.palette.primary.main
    },
    statusSpan: {
        verticalAlign: "middle"
    },
    customChip: {
        backgroundColor: theme.palette.primary.main
    }
}));

export default customAssetRowStyle;